import { createSelector } from 'reselect';
import { getFilterValues } from './getFilterValues';
import { DEFAULT_CHAT_FILTERS } from '../constants/defaultChatFilters';
import { getSearch } from '../operators/chatFilterGetters';
export const hasSearchSet = createSelector([getFilterValues], filterValues => {
  return getSearch(filterValues) !== getSearch(DEFAULT_CHAT_FILTERS);
});